const ConditionalWrapper = ({ wrapper, condition, children }: any) => {
  if (wrapper && !!condition) {
    return wrapper(children);
  }
  return children;
};

export { ConditionalWrapper };
